import {
  GET_TIMEOFF_DASHBOARD_DATA_SUCCESS,
  GET_TIMEOFF_DASHBOARD_DATA_FAILS,
} from "../actionTypes";

const initialState = {
  timeOffData: [],
  loading: false,
  error: null,
};

const memberTimeOffApprovalReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_TIMEOFF_DASHBOARD_DATA_SUCCESS:
      return {
        ...state,
        timeOffData: action.payload,
        loading: false,
        error: null,
      };
    case GET_TIMEOFF_DASHBOARD_DATA_FAILS:
      return {
        ...state,
        loading: false,
        error: action.payload, // Assuming payload contains error details
      };
    default:
      return state; // Ensure it returns the state when no action is matched
  }
};

export default memberTimeOffApprovalReducer;
